import AccessChecker from '@/auth/AccessChecker';
import rules from './rules';

const accessChecker = new AccessChecker(rules);

export function isGranted(action: string, ...args: any[]): boolean {
  return accessChecker.isGranted(action, ...args);
}
